import { Col, Input, Modal, ModalBody, Row } from "reactstrap";
import PrimaryButton from "../../../../../../../components/common/PrimaryButton/PrimaryButton";

const AddAccountsModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen);

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "50%",
          maxWidth: "80%",
        }}
      >
        <ModalBody>
          <div className="text-center">
            <div className="my-3 fw-medium fs-4">Add Bank Account</div>
          </div>

          <div className="d-flex flex-column gap-2 px-3">
            <div>
              <div className="fw-medium">Bank Name</div>
              <Input placeholder="Bank name" />
            </div>

            <Row>
              <Col>
                <div>
                  <div className="fw-medium">Card holder Name</div>
                  <Input placeholder="Card holder name" />
                </div>
              </Col>
              <Col>
                <div>
                  <div className="fw-medium">Card holder Phone Number</div>
                  <Input placeholder="Phone" />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div>
                  <div className="fw-medium">Country</div>
                  <Input placeholder="Country" />
                </div>
              </Col>
              <Col>
                <div>
                  <div className="fw-medium">City</div>
                  <Input placeholder="City" />
                </div>
              </Col>
            </Row>

            <div>
              <div className="fw-medium">Address</div>
              <Input placeholder="Address" />
            </div>

            <div>
              <div className="fw-medium">Bank Address</div>
              <Input placeholder="Bank Address" />
            </div>

            <Row>
              <Col>
                <div>
                  <div className="fw-medium">Bank Account Number</div>
                  <Input placeholder="Bank Account Number" />
                </div>
              </Col>
              <Col>
                <div>
                  <div className="fw-medium">Branch Code</div>
                  <Input type="number" placeholder="Branch Code" />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div>
                  <div className="fw-medium">IBAN Number</div>
                  <Input placeholder="IBAN Number" />
                </div>
              </Col>
              <Col>
                <div>
                  <div className="fw-medium">IBAN Number</div>
                  <Input type="number" placeholder="IBAN Number" />
                </div>
              </Col>
            </Row>
          </div>

          <div className="d-flex justify-content-end mt-3 px-3">
            <span className="d-flex gap-2">
              <PrimaryButton name="Add Account" />
              <div
                className="border border-dark rounded rounded-3 px-2 py-1 cursor-pointer d-flex align-items-center justify-content-center"
                onClick={toggle}
              >
                Cancel
              </div>
            </span>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AddAccountsModal;